import React from 'react';
import { ReactComponent as Circle } from "Icons/circle1.svg";
import { ReactComponent as Truck } from "Icons/transporter-truck.svg";
import { ReactComponent as CFS } from "Icons/cfs.svg";
import { ReactComponent as CHA } from "Icons/cha.svg";
import { ReactComponent as FreightForwarder } from "Icons/freight-forwarder.svg";
import { SUB_RFQ_TYPES } from 'Constants/commonConstants';

const RFQCard = (props) => {
    const getRFQImg = (type) => {
        let typeImg = <Truck className='inside-img'/>;
        if(type === 13) {
            typeImg = <CHA className='inside-img'/>;
        } else if(type === 14) {
            typeImg = <CFS className='inside-img'/>;
        } else if(type === 15) {
            typeImg = <FreightForwarder className='inside-img'/>;
        }
        return typeImg
    }
    return (
        <div className='mainSubRfqTypes'>
            <div className='subRfqMain'>
                <div className='tCenter createRFQText mb-20'>Create RFQ</div>
                <div className=' flex flex-center flex-wrap mb-50 tStart'>
                {(SUB_RFQ_TYPES || []).map((subType, index) => {
                    return(<div className={`subTypeCard curP ml-20 mr-20 card${index + 1}`} key={subType.id} onClick={() => props.onClickRFQ(subType.rfq_type)}>
                        <div>
                            <Circle className='tCenter m-30 svg-circle' />
                            {getRFQImg(subType.rfq_type)}
                        </div>
                        <div className='sublabel ht-50 tCenter'>{subType.name}</div>
                    </div>)})}
                </div>
                {/* <button className='createButton' onClick={props.onClickRFQ}>Create RFQ</button> */}
            </div>
        </div>
    )
}

export default RFQCard;


